import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/AboutUs.css';

const AboutUs = () => {
  return (
    <>
      <Helmet>
        <title>About Us - Redbox Global | Real-Time Market News Platform</title>
        <meta name="description" content="Redbox Global delivers the fastest news feed service for market-moving news. Real-time alerts, proprietary algorithms, and expert analysis for financial professionals." />
        <meta name="keywords" content="about redbox, market news platform, financial news service, trading news, real-time alerts, market intelligence, financial professionals" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/about-us" />
        <meta property="og:title" content="About Us - Redbox Global | Real-Time Market News Platform" />
        <meta property="og:description" content="The fastest news feed service for market-moving news with proprietary algorithms and expert analysis." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/about-us" />
        <meta name="twitter:title" content="About Us - Redbox Global | Real-Time Market News Platform" />
        <meta name="twitter:description" content="The fastest news feed service for market-moving news with proprietary algorithms and expert analysis." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-504711434969-e33886168f5c?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/about-us" />
      </Helmet>
      
      <div className="about-us-container">
        <div className="about-us-hero">
          <h1>About Us</h1>
          <h2 className="hero-subtitle">The Fastest News feed Service For Market Moving News</h2>
        </div>
        
        <div className="about-us-content">
          <section className="about-description">
            <p>
              Redbox is a platform which utilizes proprietary algorithms, a network of traders, brokers, journalists, and analysts helping us 
              deliver the best information you need when it breaks. We deliver the earliest possible alerts of the real-time emerging market-moving 
              news. Our software then uses its alert urgency ranking feature to deliver tailored insights to make decisions quickly. This helps you 
              make better decisions within the financial markets and how best to place positions on the buy and sell side, with a better insight 
              comes better opportunities for profitable decisions.
            </p>
            
            <p>
              Financial professionals are using Redbox to learn about market-moving events sooner and generating trading signals faster. Redbox 
              gathers all your news in one place from USA Non-Farm Payroll data the moment it is announced to the latest agricultural production 
              numbers. Instead of spending all day searching multiple news websites, blogs and forums we condense all of this information in one 
              place to help you place trades more intelligently and having a better understanding of why the market may move. As well as reading 
              the news, our fundamental and technical analysts can help guide you on where they can see emerging opportunities and good places to 
              book your profits.
            </p>
            
            <p>
              Social media has changed the landscape of reporting news, utilizing our powerful API we have created a global sensor. No longer do 
              you have to scroll endlessly through websites, newsletters, blogs, and reports yourself. No longer do you have to wait from the moment 
              the news breaks for a journalist to write up an article and for it to be approved to then for it to be put on a site or sent out as a 
              newsletter when the market has already moved. You are no longer last to know, our news comes to you direct, enabling you to act faster 
              than ever before, cutting out middlemen and enabling you to gain an advantage over the competition.
            </p>
          </section>

          <section className="key-features-section">
            <h2 className="features-title">Redbox Key Features</h2>
            
            <ul className="features-list">
              <li>Delivers news on Equities, fixed income, FX and commodities</li>
              <li>Proprietary ranking system orders the news in market-moving importance</li>
              <li>We scan social media for the market moving news you need</li>
              <li>An alert feature on highest priority news</li>
              <li>An encrypted messaging service to stay in contact with brokers and fellow traders</li>
              <li>Our selected group of analysts don't just tell you their thoughts, they provide unrivalled country coverage, including economic, political and risk analysis</li>
              <li>An API available on request to integrate into mobile and trading applications</li>
            </ul>
          </section>

          <section className="services-section">
            <div className="service-card">
              <div className="service-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 10H16M8 14H16M6 22H18C19.1046 22 20 21.1046 20 20V4C20 2.89543 19.1046 2 18 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <h3>REDBOX CHAT</h3>
              <p>
                Redbox has an encrypted chat facility enabling you to stay on one page, receiving any important news whilst chatting with your friends or brokers. Discussing what the news means for your trading decisions.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3>REDBOX ANALYSTS</h3>
              <p>
                Our Redbox Analysts have over 100 years of combined experience in the financial markets. Our analysts live and breathe the markets, seeking the best opportunity for profits.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C13.1046 2 14 2.89543 14 4V6C14 7.10457 13.1046 8 12 8C10.8954 8 10 7.10457 10 6V4C10 2.89543 10.8954 2 12 2Z" stroke="currentColor" strokeWidth="2"/>
                  <path d="M6 8C7.10457 8 8 8.89543 8 10V14C8 15.1046 7.10457 16 6 16C4.89543 16 4 15.1046 4 14V10C4 8.89543 4.89543 8 6 8Z" stroke="currentColor" strokeWidth="2"/>
                  <path d="M18 8C19.1046 8 20 8.89543 20 10V14C20 15.1046 19.1046 16 18 16C16.8954 16 16 15.1046 16 14V10C16 8.89543 16.8954 8 18 8Z" stroke="currentColor" strokeWidth="2"/>
                  <path d="M12 16C13.1046 16 14 16.8954 14 18V20C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20V18C10 16.8954 10.8954 16 12 16Z" stroke="currentColor" strokeWidth="2"/>
                </svg>
              </div>
              <h3>REDBOX API</h3>
              <p>
                Redbox can provide you an API which can be integrated to your trading platforms and mobile applications, giving you more flexibility on how to receive your news.
              </p>
            </div>
          </section>
        </div>

        {/* <div className="copyright-section">
          <p>©Redboxglobal, All rights reserved to www.redboxglobal.com</p>
        </div> */}
      </div>
    </>
  );
};

export default AboutUs;
